import { Record, Map } from 'immutable';
import { createUserActions, actionTypes } from './portal-setup.actions';
import * as api from '../api';
import * as setupConstants from './portal-setup-constants';

export const PortalSetupState = Record({
  userCreationState: api.ApiCallState({}),
  value: Map({
    [setupConstants.participantsSection]: 500,
  }),
  validation: [],
  showValidation: false,
});

export const portalSetupReducer = (initialState = new PortalSetupState(), action) => {

  var state = initialState;
  state = state.set('userCreationState',
    api.apiCallReducer(state.get('userCreationState'), action, createUserActions));


  switch (action.type) {
    case createUserActions.success:
      return state.set('value', new Map())
                  .set('showValidation', false);
    case actionTypes.UPDATE_VALUE:
      return state.setIn(action.path, action.value);
    case actionTypes.UPDATE_VALIDATION:
      return state.set('validation', action.value);
    case actionTypes.SHOW_VALIDATION:
      return state.set('showValidation', true);
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/portal-setup/portal-setup.reducer.js